<form [formGroup]="faultFormGroup" class="fault-form-container">
  <div class="note-and-buttons">
    <!-- Acknowledged Checkbox -->
    <div class="form-field checkbox-field">
        <label for="acknowledged-input-{{ index() }}">
        <input
            type="checkbox"
            id="acknowledged-input-{{ index() }}"
            formControlName="acknowledged"
        />
        <span>Complete Review</span>
        </label>
    </div>

    <!-- Note Textarea -->
    <div class="form-field text-field">
        <mat-form-field>
            <textarea matInput placeholder="Optional Notes" formControlName="note"></textarea>
        </mat-form-field>
    </div>

    <div>
        <button mat-button color="primary" (click)="setClipboard()" [disabled]="faultFormGroup.invalid">
            <mat-icon>content_copy</mat-icon>Copy
        </button>
        <button mat-button color="primary" (click)="pasteClipboard()" [disabled]="!clipboardSet">
            <mat-icon>content_paste</mat-icon>Paste
        </button>
        <button mat-button color="primary" (click)="undoChanges()" [disabled]="!faultFormGroup.dirty">
            <mat-icon>undo</mat-icon>Undo
        </button>
        <button mat-button color="primary" (click)="saveEntry()" [disabled]="!faultFormGroup.dirty || faultFormGroup.invalid">
            <mat-icon>save</mat-icon>Save
        </button>
    </div>


  </div>

</form>
